import { render, staticRenderFns } from "./free_vs_premium_comparison_table.vue.js?vue&type=template&id=0f77e846&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=template&id=0f77e846&vue3"
import script from "./free_vs_premium_comparison_table.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=script&lang=js&vue3"
export * from "./free_vs_premium_comparison_table.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=script&lang=js&vue3"
import style0 from "./free_vs_premium_comparison_table.vue.css?vue&type=style&index=0&id=0f77e846&prod&lang=css&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=style&index=0&id=0f77e846&prod&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports